import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const Enterprise: IFeatureMap = {
  data: {
    includedKnownPeople: 100000,
    // 300x Known People
    includedAnonymousPeople: 300 * 100000,
    // 300k Known People actions (monthly)
    trackedActivities: 300000,
    // 20k Known People (monthly)
    emailsSent: 20000,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 200,
    conversionPixels: Infinity,
    implementationsPageVisible: false,
    zapier: Infinity,
    directIntegrations: Infinity,
    iMISDirectIntegration: true,
    blackbaudDirectIntegration: true,
  },
  ads: {
    [retargeting]: true,
    // 10 published/active (monthly)
    [mobileGeoFencing]: 10,
    // 10 published/active (monthly)
    [mobileGeoFenceRetargeting]: 10,
    [facebook]: true,
    [emailListFacebook]: true,
    // 10 published/active (monthly)
    [emailList]: 10,
    [search]: true,
    [seedSegment]: true,
    [affinity]: true,
    [googleAdsSmart]: true,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: true,
    domainsAuthenticated: Infinity,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    // 100/month
    adBannerCreator: 100,
  },
  invites: {
    [invites]: true,
    partnerManager: true,
    partnersPerProject: Infinity,
    partnerMarketingCollateralBuilder: true,
    partnerDashboards: Infinity,
  },
  monetization: {
    sponsoredRetargetingCampaigns: true,
    liveSponsorReports: true,
  },
  other: {
    flights: true,
    forms: true,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: 'cost-per-ip',
    users: 150,
    childAccountsWithSwitcher: Infinity,
    childAccountSharingWithPermissionManagement: Infinity,
    customUserRolesAndPermissionsManagement: true,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: 0,
    livePhoneSupport: false,
    dataIntegrationServicesActiveWithLicense: false,
    proResourcesPageVisible: false,
  },
};
